import { render } from "./Impress.vue?vue&type=template&id=a21ac79a&ts=true"
import script from "./Impress.vue?vue&type=script&lang=ts"
export * from "./Impress.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__